import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Col, Form, FormGroup, Input, Label, Row, UncontrolledTooltip } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { useDebounce } from "use-debounce";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import instance from "../../../axiosInstance";
import { useClaimFormContext } from "../../../context/administration/claimForm";
import { fetchAddressByPostcode } from "../../../utils/forms";
import { validateAlphaNumeric, validateEmail } from "../../../utils/validations";
import ContactInput from "../../UI/forms/ContactInput";
import { booleanOptions } from "../ClaimForm/ClientDetails";
import { toastr } from "react-redux-toastr";

const Defendent = ({ caseId }) => {
  const {
    defendant_title,
    setDefendantTitle,
    defendant_first_name,
    setDefendantFirstName,
    defendant_last_name,
    setDefendantLastName,
    defendant_email,
    setDefendantEmail,
    defendant_registration_number,
    setDefendantRegistrationNumber,
    defendant_policy_number,
    setDefendantPolicyNumber,
    defendant_address,
    setDefendantAddress,
    defendant_post_code,
    setDefendantPostCode,
    defendant_make_model,
    setDefendantMakeModel,
    defendant_color,
    setDefendantColor,
    defendant_contact_no,
    setDefendantContactNo,
    defendant_insurance,
    setDefendantInsurance,
    defendant_insurer,
    setDefendantInsurer,
    defendantValidation,
    setDefendantValidation,
    service_types
  } = useClaimFormContext();

  const isHireTabEnabled = service_types?.includes("hire");

  const [debouncedPostcode] = useDebounce(defendant_post_code, 500);
  const [duplicateCases, setDuplicateCases] = useState([]);
  const [isCheckingDuplicates, setIsCheckingDuplicates] = useState(false);

  // const fetchAddress = async (newPostCode) => {
  //   const newAddress = await fetchAddressByPostcode(newPostCode);

  //   if (newAddress !== 404) {
  //     setDefendantAddress(newAddress.address);
  //   }
  // };

  // useEffect(() => {
  //   if (debouncedPostcode?.trim() !== "") {
  //     fetchAddress(debouncedPostcode);
  //   }
  // }, [debouncedPostcode]);

  const checkDuplicateRegistration = async (registrationNumber) => {
    if (!registrationNumber || !registrationNumber.trim()) {
      setDuplicateCases([]);
      return;
    }

    try {
      setIsCheckingDuplicates(true);
      const res = await instance.get(`/case/checkDuplicateRegistration`, {
        params: {
          registration_no: registrationNumber.trim(),
          case_id: caseId || 0,
        },
      });
      const { data } = res.data;
      setDuplicateCases(data.duplicate_cases || []);
    } catch (error) {
      console.error("Error checking duplicate registration:", error);
      setDuplicateCases([]);
    } finally {
      setIsCheckingDuplicates(false);
    }
  };

  return (
    <Form>
      <h4>Defendant Details</h4>

      <Row>
        <Col md={4}>
          <FormGroup>
            <Label for="title" className="d-inline-flex align-items-center">
              Title
              {isHireTabEnabled && (
                <>
                  <FontAwesomeIcon icon={faInfoCircle} id="tooltip-def-title" className="text-danger ml-1 cursor-pointer" style={{ fontSize: "12px" }} />
                  <UncontrolledTooltip placement="top" target="tooltip-def-title">
                    This field is mandatory in Enterprise posting
                  </UncontrolledTooltip>
                </>
              )}
            </Label>
            <Input type="select" id="defendantTitle" name="defendantTitle" value={defendant_title} onChange={(e) => setDefendantTitle(e.target.value)}>
              <option value="mr.">Mr.</option>
              <option value="mrs.">Mrs.</option>
              <option value="ms.">Ms.</option>
              <option value="miss.">Miss.</option>
              <option value="mstr.">Mstr.</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label for="defendantFirstName" className="d-inline-flex align-items-center">
              First Name
              {isHireTabEnabled && (
                <>
                  <FontAwesomeIcon icon={faInfoCircle} id="tooltip-def-first" className="text-danger ml-1 cursor-pointer" style={{ fontSize: "12px" }} />
                  <UncontrolledTooltip placement="top" target="tooltip-def-first">
                    This field is mandatory in Enterprise posting
                  </UncontrolledTooltip>
                </>
              )}
            </Label>
            <Input type="text" id="defendantFirstName" autoComplete="off" value={defendant_first_name} onChange={(e) => setDefendantFirstName(e.target.value)} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label for="defendantLastName" className="d-inline-flex align-items-center">
              Surname
              {isHireTabEnabled && (
                <>
                  <FontAwesomeIcon icon={faInfoCircle} id="tooltip-def-last" className="text-danger ml-1 cursor-pointer" style={{ fontSize: "12px" }} />
                  <UncontrolledTooltip placement="top" target="tooltip-def-last">
                    This field is mandatory in Enterprise posting
                  </UncontrolledTooltip>
                </>
              )}
            </Label>
            <Input type="text" id="defendantLastName" autoComplete="off" value={defendant_last_name} onChange={(e) => setDefendantLastName(e.target.value)} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label for="defendantAddress">Address</Label>
            <Input type="text" autoComplete="off" id="defendantAddress" value={defendant_address} onChange={(e) => setDefendantAddress(e.target.value)} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label for="defendantPostCode">Post Code</Label>
            <Input
              type="text"
              id="defendantPostCode"
              autoComplete="off"
              className={defendantValidation.postCode ? "is-invalid" : ""}
              value={defendant_post_code}
              onChange={(e) => {
                const { value } = e.target;
                setDefendantPostCode(value);
                setDefendantValidation({
                  ...defendantValidation,
                  postCode: !value || validateAlphaNumeric(value) ? "" : "Invalid post code!",
                });
              }}
            />
            <small className="text-danger">{defendantValidation.postCode}</small>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label for="defendantEmail">Email Address</Label>
            <Input
              type="email"
              id="defendantEmail"
              className={defendantValidation.emailAddress ? "is-invalid" : ""}
              value={defendant_email}
              autoComplete="off"
              onChange={(e) => {
                const { value } = e.target;
                setDefendantEmail(value);
                setDefendantValidation({ ...defendantValidation, emailAddress: !value || validateEmail(value) ? "" : "Invalid email address!" });
              }}
            />
            <small className="text-danger">{defendantValidation.emailAddress}</small>
          </FormGroup>
        </Col>
        <Col md={4}>
          <ContactInput
            name="defendantContactNo"
            label="Contact Number"
            value={defendant_contact_no}
            onChange={setDefendantContactNo}
            isInvalid={defendantValidation.contactNo}
            setError={[setDefendantValidation, "contactNo"]}
          />
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label for="defendantRegistrationNumber" className="d-inline-flex align-items-center">
              Registration Number
              {isHireTabEnabled && (
                <>
                  <FontAwesomeIcon icon={faInfoCircle} id="tooltip-def-reg" className="text-danger ml-1 cursor-pointer" style={{ fontSize: "12px" }} />
                  <UncontrolledTooltip placement="top" target="tooltip-def-reg">
                    This field is mandatory in Enterprise posting
                  </UncontrolledTooltip>
                </>
              )}
            </Label>
            <Input
              type="text"
              id="defendantRegistrationNumber"
              autoComplete="off"
              value={defendant_registration_number}
              onChange={(e) => {
                if(e.target.value?.includes(" ")){
                  toastr.info("Registration number cannot contain spaces!")
                }
                setDefendantRegistrationNumber(e.target.value?.replaceAll(" ", "")?.trim())}}
              onBlur={(e) => checkDuplicateRegistration(e.target.value?.replaceAll(" ", "")?.trim())}
            />
            {isCheckingDuplicates && (
              <small className="text-muted">Checking for duplicates...</small>
            )}
            {!isCheckingDuplicates && duplicateCases.length > 0 && (
              <div className="mt-2">
                <small className="text-warning d-block mb-1">
                  Duplicate registration found in cases:
                </small>
                <div>
                  {duplicateCases.map((caseEntry, index) => {
                    // Parse format: "V: 123", "D: 456", or "V/D: 789"
                    const match = caseEntry.match(/^([VD\/]+):\s*(\d+)$/);
                    const prefix = match ? match[1] : '';
                    const caseId = match ? match[2] : caseEntry;
                    return (
                      <React.Fragment key={caseEntry}>
                        <span>{prefix}: </span>
                        <Link
                          to={`/administration/cases/${caseId}`}
                          target="_blank"
                          className="text-primary"
                        >
                          {caseId}
                        </Link>
                        {index < duplicateCases.length - 1 && <span>, </span>}
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            )}
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label for="defendantMakeModel" className="d-inline-flex align-items-center">
              Make/ Model
              {isHireTabEnabled && (
                <>
                  <FontAwesomeIcon icon={faInfoCircle} id="tooltip-def-make" className="text-danger ml-1 cursor-pointer" style={{ fontSize: "12px" }} />
                  <UncontrolledTooltip placement="top" target="tooltip-def-make">
                    This field is mandatory in Enterprise posting
                  </UncontrolledTooltip>
                </>
              )}
            </Label>
            <Input type="text" autoComplete="off" id="defendantMakeModel" value={defendant_make_model} onChange={(e) => setDefendantMakeModel(e.target.value)} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label for="defendantColor">Colour</Label>
            <Input type="text" autoComplete="off" id="defendantColor" value={defendant_color} onChange={(e) => setDefendantColor(e.target.value)} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label for="defendantInsurance">Has TP Insurance?</Label>
            <Select id="defendantInsurance" className="basic-single" classNamePrefix="select" value={defendant_insurance} onChange={(value) => setDefendantInsurance(value)} options={booleanOptions} />
          </FormGroup>
        </Col>
        {defendant_insurance?.label === "Yes" && (
          <Col md={4}>
            <FormGroup>
              <Label for="defendantInsurer">TP Insurer Name</Label>
              <Input type="text" autoComplete="off" id="defendantInsurer" value={defendant_insurer} onChange={(e) => setDefendantInsurer(e.target.value)} />
            </FormGroup>
          </Col>
        )}
        <Col md={4}>
          <FormGroup>
            <Label for="defendantPolicyNumber">TP Insurance Policy Number</Label>
            <Input type="text" id="defendantPolicyNumber" autoComplete="off" value={defendant_policy_number} onChange={(e) => setDefendantPolicyNumber(e.target.value)} />
          </FormGroup>
        </Col> 
      </Row>
    </Form>
  );
};

export default Defendent;
